import { useContext } from 'react';
import gql from 'graphql-tag';
import store from 'store';
import { UTILITY_CREDENTIAL_ID_FOR_SYNC } from 'domain/utility-credentials';
import { Notification } from '@perch-labs/shrike';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { copyFor } from 'config';
import { NOTIFICATION_DISPLAY_TIME } from 'domain/ux';
import { useAsync } from './use-async.hook';

interface UtilityCredential {
  id: number;
  password: string | null;
  redirectUri: string;
}
interface Props {
  utilityCredential: UtilityCredential;
  redirectRoute: string;
}

export const useUpdateUtilityCredential = ({
  utilityCredential,
  redirectRoute,
}: Props) => {
  const { redirectUri, password, id } = utilityCredential;
  const getCopy = copyFor('toastNotifications');
  const { addNotification } = useContext(Notification.Context);
  const history = useHistory();
  const [mutate] = useMutation(UPDATE_UTILITY_CREDENTIAL_MUTATION);
  const mutationVariables = {};

  if (password) (mutationVariables as any).password = password;
  // redirectUri: ApiToken utility creds (Ameren) requirement
  if (redirectUri) (mutationVariables as any).redirectUri = redirectUri;

  const [{ error, loading }, submit] = useAsync(async () => {
    await mutate({
      variables: {
        id,
        input: mutationVariables,
      },
    });

    store.remove(UTILITY_CREDENTIAL_ID_FOR_SYNC);

    addNotification({
      displayTime: NOTIFICATION_DISPLAY_TIME,
      message: getCopy('update', { content: 'Utility sync information' }),
      variant: 'success',
    });
    history.push(redirectRoute);
  });

  return [{ error, loading }, submit] as const;
};

export const UPDATE_UTILITY_CREDENTIAL_MUTATION = gql`
  mutation UpdateUtilityCredential(
    $id: Int!
    $input: UpdateUtilityCredentialInput!
  ) {
    updateUtilityCredential(id: $id, input: $input) {
      id
      type
      username
      verificationStatus
    }
  }
`;

export const updateUtilityCredentialMock = {
  updateUtilityCredential: {
    id: 12,
    password: 'not-secret-at-all',
    type: 'UsernamePassword',
    username: 'overide@hey.com',
    verificationStatus: 'unverified',
  },
};
